/**
 * REG-828 (COLUMNS sheet): Created At and Most Recent Update read
 * "Thursday, September 10, 2026 at 9:11:45 PM". Shown in New York time, the
 * time zone the business runs on, so every viewer sees the same day and hour.
 */
const LONG_DATE_TIME = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit',
  hour12: true,
});

/** "Thursday, September 10, 2026 at 9:11:45 PM", or '' for an empty or invalid value. */
export function formatLongDateTime(value: string | number | Date | null | undefined): string {
  if (value == null || value === '') return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  // Assembled from parts: browsers disagree on the word between date and time.
  const part = Object.fromEntries(LONG_DATE_TIME.formatToParts(date).map((p) => [p.type, p.value]));
  return `${part.weekday}, ${part.month} ${part.day}, ${part.year} at ${part.hour}:${part.minute}:${part.second} ${part.dayPeriod}`;
}

const SHORT_DATE = new Intl.DateTimeFormat('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' });

/** How long ago `value` was, as "7 mo", "2y" or "2y 3mo". */
export function tenureLabel(value: string | null | undefined, now: number = Date.now()): string {
  if (!value) return '';
  const start = new Date(value).getTime();
  if (Number.isNaN(start)) return '';
  const months = Math.max(0, Math.floor((now - start) / 2_629_800_000));
  if (months < 12) return `${months} mo`;
  const years = Math.floor(months / 12);
  const remainder = months % 12;
  return remainder ? `${years}y ${remainder}mo` : `${years}y`;
}

/** REG-828 "Start Date / Tenure": "3/4/25 · 1y 7mo", or '-' with no start date. */
export function startDateWithTenure(value: string | null | undefined, now: number = Date.now()): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return `${SHORT_DATE.format(date)} · ${tenureLabel(value, now)}`;
}
